// Retorna un String sin tildes, ni espacios. Usado para Zips
const formatedTextForZip = (text) => {
    return text
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, "_")
        .replace(/[^\w-]/g, "");
};

export { formatedTextForZip };